(function() { window.GUID_87472d3e_3c5a_4351_8906_44401f4fd542 = { getGuid: function() { return "87472d3e-3c5a-4351-8906-44401f4fd542"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            /** This class handle all about the video timeLine  */
            class ProgressTooltips extends VideoPlayerInternals.BaseInternal {
                constructor(videoProgress) {
                    super(videoProgress.player);
                    this.videoProgress = videoProgress;
                    this.loadingThumb = false;
                    var container = this.player.$Control;
                    this.video = this.player.video;
                    this.progressContainer = this.elements.progressContainer;
                    this.tooltipsContainer = container.find('.time-tooltips');
                    this.image = container.find('.image-tooltips');
                    this.cursor = container.find('.time-cursor-tooltips');
                    var progress = this.progressContainer.find('.progress');
                    if (progress.length > 0)
                        this.progressBar = progress[0];
                }
                OnBindEvents() {
                    this.event(this.progressContainer)
                        .offon("mouseenter", (e, s) => { this.show(); })
                        .offon("mousemove", (e, s) => { this.progressContainer_MouseMove(e); })
                        .offon("mouseleave", (e, s) => { this.hide(); });
                }
                OnDispose() {
                }
                show() {
                    this.tooltipsContainer.removeClass("hide");
                }
                hide() {
                    this.tooltipsContainer.addClass("hide");
                }
                update(x, useRequestAnimationFrame = true) {
                    var secondsPosition = this.videoProgress.positionToSeconds(x);
                    var tooltipsCenter = this.tooltipsContainer.outerWidth() / 2;
                    var newX = 0;
                    if (x <= tooltipsCenter) {
                        newX = 0;
                    }
                    else if (x >= this.progressContainer.width() - tooltipsCenter)
                        newX = this.progressContainer.width() - (tooltipsCenter * 2);
                    else
                        newX = x - tooltipsCenter;
                    var animateCB = () => {
                        this.tooltipsContainer.css("left", newX);
                        this.cursor.text(this.displaySeconds(secondsPosition));
                        // this is to prevent to manny seek in the video used to get image.
                        if (!this.loadingThumb) {
                            this.loadingThumb = true;
                            this.player.videoThumbnail.GetImage(secondsPosition, (imageData) => {
                                this.image.attr("src", imageData);
                                this.loadingThumb = false;
                            }, { Height: 100, Width: null });
                        }
                    };
                    if (useRequestAnimationFrame)
                        requestAnimationFrame(animateCB);
                    else
                        animateCB();
                }
                progressContainer_MouseMove(event) {
                    var x = event.pageX - this.progressContainer.offset().left;
                    this.update(x);
                }
            }
            VideoPlayerInternals.ProgressTooltips = ProgressTooltips;
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.ProgressTooltips.js.map
